
<template lang="pug">
  .eui-searchInput(:class="{ 'eui-searchInput_dense': dense }")
    input.eui-searchInput_input(:placeholder="placeholderText", v-model.trim="searchValue", @focus="inputClick", @blur="handleBlur")
    .eui-searchInput_icon
      CloseIcon(v-if="searchValue", @click="handleClear")
      SearchIcon(v-else)
</template>


<script>
import CloseIcon from '../../assets/icon-cross.svg';
import SearchIcon from '../../assets/icon-search.svg';

import Button from '../Button/Button.vue';

export default {
  name: 'eui-searchInput',
  props: {
    name: { type: String },
    placeholder: {
      type: String,
      default: 'Find your Electorate'
    },
    dense: { type: Boolean }
  },
  data() {
    return {
      searchValue: null,
      focused: false
    };
  },
  computed: {
    placeholderText() {
      return this.focused ? '' : this.placeholder;
    },
  },
  methods: {
    handleBlur() {
      setTimeout(() => {
        this.focused = false;
      }, 100);
    },
    inputClick() {
      this.focused = true;
    },
    handleClear() {
      this.searchValue = null;
      this.focused = false;
    }
  },
  watch: {
    searchValue(value) {
      this.$emit('inputChange', value);
      if (!value) {
        this.focused = false;
      }
    },
    focused(value) {
      this.$emit('focusChange', value);
    }
  },
  components: {
    CloseIcon,
    Button,
    SearchIcon
  }
};

</script>

<style lang="scss">
.eui-searchInput {
  --icon-size: 16px;
  --button-color: var(--color-body);
  border: 1px solid var(--button-color);
  background: #fff;
  color: var(--button-color);
  max-width: 100%;
  padding: var(--spacing-unit) var(--spacing-unit-x2);
  border-radius: var(--spacing-unit-x2);
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &_input {
    border: 0;
    outline: 0;
    flex: 1;
    padding: 0;
  }


  &_icon {
    display: block;
    height: var(--icon-size);
    margin-left: var(--spacing-unit-x0_5);

    svg {
      width: var(--icon-size);
      height: var(--icon-size);
      path {
        fill: currentColor;
      }
    }
  }

  &:hover {
    --button-color: var(--color-title);
  }

  &_dense {
    --icon-size: 14px;
    padding: var(--spacing-unit-x0_5) var(--spacing-unit);
  }
}

</style>
